import { Dispatch, SetStateAction, useState } from "react";

interface Props {
  children: (
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
  ) => React.ReactElement;
}

export default function CartOpenStateWrapper({ children }: Props) {
  const [open, setOpen] = useState(false);

  return children(open, setOpen);
}
